package one.healthium.insights.ui.components.items

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.CardModel
import one.healthium.insights.domain.models.testTag
import one.healthium.ui.NetworkImage
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black10
import one.healthium.ui.compose.theme.black40

@Composable
fun Carousel(
    modifier: Modifier = Modifier,
    content: List<CardModel>,
    variant: String? = null,
    onClick: (ActionModel) -> Unit,
) {
    LazyRow(
        modifier = modifier
            .fillMaxWidth()
            .height(200.dp)
            .testTag("insights_carousel_$variant"),
        contentPadding = PaddingValues(horizontal = 12.dp),
        horizontalArrangement = Arrangement.spacedBy(6.dp),
    ) {
        items(content.size) { index ->
            val todayEntry = content.getOrNull(index) ?: return@items

            Box(
                Modifier.fillMaxHeight().width(variant.pageSize)
            ) {
                when (variant) {
                    "today" -> TodayCard(todayEntry, onClick)
                    "recipes" -> RecipesCard(todayEntry, onClick)
                    "suggestions" -> TodayCard(todayEntry, onClick)
                    else -> TodayCard(todayEntry, onClick)
                }
            }
        }
    }
}

@Composable
private fun TodayCard(
    model: CardModel,
    onClick: (ActionModel) -> Unit,
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(black10, AppTheme.shapes.small)
            .clip(AppTheme.shapes.small)
            .clickable { onClick(model.action) }
            .testTag(model.action.testTag("today_card")),
    ) {
        NetworkImage(
            imageUrl = model.thumbUrl,
            modifier = Modifier.fillMaxSize(),
            contentScale = ContentScale.Crop
        )
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .background(black40)
                .padding(24.dp)
                .align(Alignment.BottomCenter)
        ) {
            Text(
                text = model.title,
                style = AppTheme.textStyles.secondary_17_600,
                color = AppTheme.colors.textInverted100,
                maxLines = 2,
                overflow = TextOverflow.Ellipsis,
            )
        }
    }
}

@Composable
private fun RecipesCard(
    model: CardModel,
    onClick: (ActionModel) -> Unit,
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(black10, AppTheme.shapes.small)
            .clip(AppTheme.shapes.small)
            .clickable { onClick(model.action) }
            .testTag(model.action.testTag("today_card")),
        contentAlignment = Alignment.Center,
    ) {
        NetworkImage(
            imageUrl = model.thumbUrl,
            modifier = Modifier.fillMaxSize(),
            contentScale = ContentScale.Crop
        )
        Text(
            modifier = Modifier.padding(horizontal = 12.dp),
            text = model.title,
            style = AppTheme.textStyles.poppins26SemiBold,
            color = AppTheme.colors.textInverted100,
            maxLines = 2,
            overflow = TextOverflow.Ellipsis,
            textAlign = TextAlign.Center,
        )
    }
}

private val String?.pageSize
    get() = when (this) {
        "recipes" -> 160.dp
        else -> 275.dp
    }
